export default __webpack_public_path__ + "assets/3c1939034ad45f27362ba054b559fb18.png";